import { GAMING_LIMIT_PERIODS } from './gaming-limits.constants';
import type {
  GamingLimitHardRejectionPayload,
  GamingLimitPeriod,
} from './gaming-limits.types';

const isGamingLimitPeriod = (value: unknown): value is GamingLimitPeriod =>
  (GAMING_LIMIT_PERIODS as readonly unknown[]).includes(value);

export const parseGamingLimitHardRejectionMessage = (
  value: unknown
): GamingLimitHardRejectionPayload | null => {
  let message = value;

  if (typeof value === 'string') {
    try {
      message = JSON.parse(value);
    } catch {
      return null;
    }
  }

  if (!Array.isArray(message) || message.length !== 2) return null;

  const [kind, period] = message;

  return kind === 'hard_limit' && isGamingLimitPeriod(period)
    ? { period }
    : null;
};
